const storage = localStorage || window.localStorage;

export const setUserId = id => storage && storage.setItem('user_id', id);
export const getUserId = () => storage && storage.getItem('user_id');
export const removeUserId = () => storage && storage.removeItem('user_id');

export const setCompanyId = id => storage && storage.setItem('company_id', id);
export const getCompanyId = () => storage && storage.getItem('company_id');
export const removeCompanyId = () => storage && storage.removeItem('company_id');

export const clearProfileIds = () => {
  removeUserId();
  removeCompanyId();
};
